import { render, staticRenderFns } from "./ReportFiltersForProductWiseReport.vue?vue&type=template&id=878a9b5a&"
import script from "./ReportFiltersForProductWiseReport.vue?vue&type=script&lang=js&"
export * from "./ReportFiltersForProductWiseReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports